import fileSaver from '../../../../helpers/download.helper'
import { AxiosService } from './../../../../services/axios.service'
import { ClientReportsService } from '../../../../services/client-reports.service'
import { myPurchaseConstants } from './my-purchases.constants'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const exportData = (params) => (dispatch) => {
	dispatch({
		type: myPurchaseConstants.EXPORT_DATA,
	})
	dispatch(SiteCreators.showLoading())
	AxiosService.get(`${ClientReportsService.baseURL}/exportar-minhas-compras`, {
		responseType: 'blob',
		params: params,
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = (downloadData) => async (dispatch) => {
	dispatch({
		type: myPurchaseConstants.DOWNLOAD_DATA,
	})

	await fileSaver(downloadData, 'minhas-compras.csv')
}

export const myPurchasesActions = { exportData }
